export default {
	status: {
		400: "Požiadavka zlyhala! Prosím, skúste to neskôr",
		401: "Relácia prihlásenia vypršala! Prihláste sa znova",
		403: "Aktuálne konto nemá prístupové oprávnenie",
		404: "Zdroj, ku ktorému sa snažíte získať prístup, neexistuje",
		405: "Nesprávna metóda požiadavky! Prosím, skúste to neskôr",
		408: "Request timed out! Prosím, skúste to znova neskôr",
		500: "Služba narazila na výnimku",
		990: "Váš účet bol dlhodobo zmrazený z dôvodu nedokončených úloh",
		10030008: "Pred podaním žiadosti o výber hotovosti vráťte, prosím, asistenčný fond",
		10030010: "Kód výzvy neexistuje",
		10030011: "Prekročený maximálny počet časov registrácie",
		10030012: "Nespĺňate podmienky na prihlásenie, najskôr dokončite úlohu",
		10030013: "Chyba konfigurácie prihlásenia, kontaktujte zákaznícky servis",
		10030014: "Nie je v rámci povoleného časového obdobia",
		10030015: "Člen neexistuje",
		10030016:
			"Vážený používateľ: Gratulujeme! Úspešne ste dokončili 100 % propagácie svojho produktu. Kontaktujte podporu platformy a požiadajte o resetovanie.",
		10030017: "Nie je možné nájsť zhodný produkt, kontaktujte prosím zákaznícky servis",
		10030018: "Nedostatočný zostatok na účte",
		10030019: "Účet bol zablokovaný",
		10030020: "Účet zakázaný na obchodovanie",
		10030021: "Výber z účtu zakázaný",
		10030022: "Chyba hesla transakcie",
		10030023: "Účet na výber nie je viazaný, najskôr viažte účet na výber",
		10030024: "Chyba starého hesla",
		10030027: "Váš výber je obmedzený. Pre viac informácií kontaktujte prosím zákaznícky servis",
		10030028: "Nízke kreditné skóre vám bráni vo výbere peňazí",
		10030030: "Nie je v rámci povoleného časového obdobia",
		10030031: "Prosím, kontaktujte zákaznícky servis pre obnovenie dnešnej úlohy",
		10030050: "Objednávka vypršala. Prosím, kontaktujte zákaznícku podporu pre pomoc."
	},
	errorHandler: {
		InternalError: "Interná chyba v motore JavaScript",
		ReferenceError: "Objekt nebol nájdený",
		TypeError: "Nesprávny typ alebo použitý objekt",
		RangeError: "Parameter mimo rozsahu pri použití zabudovaných objektov",
		SyntaxError: "Chyba syntaxe",
		EvalError: "Nesprávne používanie Eval",
		URIError: "Chyba URI",
		UnknownError: "Neznáme"
	},
	Network: {
		timedout: "Žiadosť sa vyčerpala! Skúste to prosím neskôr",
		error: "Chyba siete! Skúste to prosím neskôr"
	},
	request: {
		NoMoreData: "Žiadne ďalšie údaje",
		OnlyImage: "Nahrajte iba obrazové súbory.",
		FileMaxSize: "Veľkosť súboru presahuje maximálnu hodnotu, ktorá je {0}M"
	},
	response: {
		loading: "Načítavanie",
		success: "Úspech",
		fail: "Zlyhanie",
		complete: "Kompletné"
	},
	page: {
		noVerify: "Кошелёк не подтверждён, пожалуйста, сначала подтвердите кошелёк",
		notexist: "Je nám ľúto, stránka, na ktorú sa pokúšate získať prístup, neexistuje~"
	}
};
